import { StringSchema } from 'yup';
import * as Yup from 'yup';

// Match letters, numbers, whitespace, and common symbols that
// can be used within names: `.` `,` `-` `'`
const NO_SPECIAL_SYMBOLS_REGEX = /^[A-z0-9\s-'.,]*$/;

Yup.addMethod<StringSchema>(
  Yup.string,
  'noSpecialSymbols',
  function validateNoSymbols(message) {
    return this.matches(NO_SPECIAL_SYMBOLS_REGEX, message);
  }
);

declare module 'yup' {
  interface StringSchema {
    noSpecialSymbols(message: string): StringSchema;
  }
}
